// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_list_subtitle-module__button--RohCs{font-weight:700;font-size:14px;line-height:21px;letter-spacing:0;cursor:pointer}.entity_list_subtitle-module__button--RohCs:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"button": "entity_list_subtitle-module__button--RohCs"
};
module.exports = exports;
